"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShowMultiplierLabel = exports.getMatchingPositionCount = exports.isIneligibleCriteriaForMultiplier = exports.getExceptionalAmounts = exports.getTotalWinningAmount = exports.getTotalWinningAmountWithoutMultiplier = exports.getBetTypeKeyByValue = exports.LOTTO_AMERICA = exports.DAILY_4 = exports.DAILY_3 = exports.PICK_3 = exports.createEmptyTicket = exports.checkForDailyDrawsErrors = exports.checkForPick3Errors = exports.checkForErrors = exports.DailyDrawsBetType = exports.BetType = void 0;
var BetType;
(function (BetType) {
    BetType["FIRST_DIGIT"] = "First Digit";
    BetType["FRONT_PAIR"] = "Front Pair";
    BetType["BACK_PAIR"] = "Back Pair";
    BetType["STRAIGHT"] = "Straight";
    BetType["THREE_WAY_BOX"] = "3-way Box";
    BetType["SIX_WAY_BOX"] = "6-way Box";
    BetType["STRAIGHT_THREE_WAY_BOX"] = "Straight 3-way Box";
    BetType["STRAIGHT_SIX_WAY_BOX"] = "Straight 6-way Box";
})(BetType = exports.BetType || (exports.BetType = {}));
var DailyDrawsBetType;
(function (DailyDrawsBetType) {
    DailyDrawsBetType["EXACT"] = "Exact";
    DailyDrawsBetType["ANY"] = "Any";
    DailyDrawsBetType["EXACT_ANY"] = "Exact/Any";
    DailyDrawsBetType["COMBO"] = "Combo";
})(DailyDrawsBetType = exports.DailyDrawsBetType || (exports.DailyDrawsBetType = {}));
var checkIfNumbersInRange = function (number, ticketIndex, numberIndex, from, to) {
    if (!(from <= number && number <= to)) {
        var message = "Position ".concat(numberIndex + 1, " must be a number between ").concat(from, " and ").concat(to, ".");
        var errorObject = {
            key: numberIndex + 1,
            value: message
        };
        return errorObject;
    }
    return null;
};
var checkForDuplicates = function (numbers, hasAddon) {
    var duplicates = numbers;
    if (hasAddon) {
        duplicates = numbers.slice(0, numbers.length - 1);
    }
    duplicates = duplicates.filter(function (number) { return !!number; });
    var dupIndex = findDuplicateIndexes(duplicates);
    return dupIndex;
};
function findDuplicateIndexes(arr) {
    var elementIndexes = {};
    var duplicateIndexes = [];
    arr.forEach(function (element, index) {
        if (element === null || element === '') {
            console.warn('break');
        }
        else if (elementIndexes[element]) {
            elementIndexes[element].push(index);
        }
        else {
            elementIndexes[element] = [index];
        }
    });
    for (var _i = 0, _a = Object.values(elementIndexes); _i < _a.length; _i++) {
        var indexes = _a[_i];
        if (indexes.length > 1) {
            duplicateIndexes.push.apply(duplicateIndexes, indexes);
        }
    }
    return duplicateIndexes;
}
var checkForErrors = function (tickets, main, addon) {
    var clubErrors = [];
    var _loop_1 = function (i) {
        var errors = [];
        var ticketHasDuplicates = checkForDuplicates(tickets[i].numbers, !!addon);
        var numberCount = main.digitCount + (addon ? 1 : 0);
        for (var j = 0; j < tickets[i].numbers.length; j++) {
            var number = tickets[i].numbers[j];
            var isInRangeError = void 0;
            if (j === numberCount - 1 && !!addon) {
                isInRangeError = checkIfNumbersInRange(number, i, j, addon.from, addon.to);
                if (isInRangeError) {
                    errors.push(isInRangeError);
                }
                break;
            }
            isInRangeError = checkIfNumbersInRange(number, i, j, main.from, main.to);
            if (isInRangeError) {
                errors.push(isInRangeError);
            }
        }
        if (ticketHasDuplicates) {
            ticketHasDuplicates.map(function (index) {
                var errorObject = {
                    key: index + 1,
                    value: "Position ".concat(index + 1, " has duplicate numbers.")
                };
                errors.push(errorObject);
            });
        }
        clubErrors.push(errors);
    };
    for (var i = 0; i < tickets.length; i++) {
        _loop_1(i);
    }
    return clubErrors;
};
exports.checkForErrors = checkForErrors;
var checkForPick3Errors = function (tickets, main) {
    var errorsList = [];
    var _loop_2 = function (i) {
        var errors = [];
        tickets[i].numbers.forEach(function (number, j) {
            if (number === null) {
                var emptyNumberError = {
                    key: j + 1,
                    value: "Position ".concat(j + 1, " must be a number between ").concat(main.from, " and ").concat(main.to, ".")
                };
                errors.push(emptyNumberError);
            }
        });
        var numberFrequency = {};
        var selectedNumbers = tickets[i].numbers;
        selectedNumbers.forEach(function (n) { return (numberFrequency[n] = (numberFrequency[n] || 0) + 1); });
        switch (tickets[i].betType) {
            case BetType.THREE_WAY_BOX:
            case BetType.STRAIGHT_THREE_WAY_BOX: {
                if (Object.keys(numberFrequency).length !== 2) {
                    var needDuplicateError = {
                        key: 0,
                        value: "Ticket ".concat(i + 1, " must have exactly two duplicate numbers.")
                    };
                    errors.push(needDuplicateError);
                }
                break;
            }
            case BetType.SIX_WAY_BOX:
            case BetType.STRAIGHT_SIX_WAY_BOX: {
                var ticketHasDuplicates = checkForDuplicates(tickets[i].numbers, false);
                if (ticketHasDuplicates) {
                    ticketHasDuplicates.forEach(function (index) {
                        var errorObject = {
                            key: index + 1,
                            value: "Position ".concat(index + 1, " has duplicate numbers.")
                        };
                        errors.push(errorObject);
                    });
                }
                break;
            }
            default:
                break;
        }
        errorsList.push(errors);
    };
    for (var i = 0; i < tickets.length; i++) {
        _loop_2(i);
    }
    return errorsList;
};
exports.checkForPick3Errors = checkForPick3Errors;
var checkForDailyDrawsErrors = function (isDaily3, tickets, main, addon) {
    var errors = [];
    var _loop_3 = function (i) {
        var filledPositions = tickets[i].numbers.filter(function (number) { return number !== null; });
        var numberCount = main.digitCount + (addon ? 1 : 0);
        if (filledPositions.length < numberCount) {
            errors.push("Ticket ".concat(i + 1, ": Must have ").concat(numberCount, " numbers, not ").concat(filledPositions.length, "."));
        }
        var numberFrequency = {};
        var selectedNumbers = tickets[i].numbers;
        selectedNumbers.forEach(function (n) { return (numberFrequency[n] = (numberFrequency[n] || 0) + 1); });
        switch (tickets[i].betType) {
            case DailyDrawsBetType.ANY:
            case DailyDrawsBetType.EXACT_ANY:
                if (Object.keys(numberFrequency).length < 2) {
                    errors.push("Ticket ".concat(i + 1, ": Must have at least two different numbers"));
                }
                break;
            case DailyDrawsBetType.COMBO:
                var uniqueNumbers = Object.keys(numberFrequency).length;
                var maxCount = Math.max.apply(Math, Object.values(numberFrequency));
                if (uniqueNumbers < 2 || maxCount >= 3) {
                    if (isDaily3) {
                        errors.push("Ticket ".concat(i + 1, ": Must have at least two different numbers"));
                    }
                    else {
                        errors.push("Ticket ".concat(i + 1, ": Three duplicate numbers and four Duplicate numbers are not allowed."));
                    }
                }
                break;
            default:
                break;
        }
    };
    for (var i = 0; i < tickets.length; i++) {
        _loop_3(i);
    }
    return errors;
};
exports.checkForDailyDrawsErrors = checkForDailyDrawsErrors;
var getNumberCount = function (betType) {
    switch (betType) {
        case BetType.FIRST_DIGIT:
            return 1;
        case BetType.FRONT_PAIR:
        case BetType.BACK_PAIR:
            return 2;
        case BetType.STRAIGHT:
        case BetType.THREE_WAY_BOX:
        case BetType.STRAIGHT_THREE_WAY_BOX:
        case BetType.SIX_WAY_BOX:
        case BetType.STRAIGHT_SIX_WAY_BOX:
            return 3;
        default:
            return 3;
    }
};
var createEmptyTicket = function (gameConfig, gameName) {
    var _a;
    var length = gameName === exports.PICK_3 ? 1 : ((_a = gameConfig === null || gameConfig === void 0 ? void 0 : gameConfig.main) === null || _a === void 0 ? void 0 : _a.digitCount) + ((gameConfig === null || gameConfig === void 0 ? void 0 : gameConfig.addon) ? 1 : 0);
    return {
        numbers: Array.from({ length: length }, function (_) { return null; }),
        multiplier: false,
        betType: gameName === exports.PICK_3 ? BetType.FIRST_DIGIT : DailyDrawsBetType.EXACT
    };
};
exports.createEmptyTicket = createEmptyTicket;
exports.PICK_3 = 'Pick 3';
exports.DAILY_3 = 'Daily 3';
exports.DAILY_4 = 'Daily 4';
exports.LOTTO_AMERICA = 'Lotto America';
var getBetTypeKeyByValue = function (value) {
    var found = Object.keys(BetType).find(function (key) { return BetType[key].toString() === value; });
    if (!found) {
        return Object.keys(DailyDrawsBetType).find(function (key) { return DailyDrawsBetType[key].toString() === value; });
    }
    return found;
};
exports.getBetTypeKeyByValue = getBetTypeKeyByValue;
var getTotalWinningAmountWithoutMultiplier = function (selectedGame, ticket, multiplier, withMultiplier) {
    var exceptionalAmount = (0, exports.getExceptionalAmounts)(selectedGame, ticket, withMultiplier);
    var winningAmount = exceptionalAmount > 0 ? exceptionalAmount : ticket.winningAmount;
    return (0, exports.isIneligibleCriteriaForMultiplier)(selectedGame, ticket) && withMultiplier
        ? winningAmount / multiplier
        : winningAmount;
};
exports.getTotalWinningAmountWithoutMultiplier = getTotalWinningAmountWithoutMultiplier;
var getTotalWinningAmount = function (selectedGame, ticket, multiplier, withMultiplier) {
    var exceptionalAmount = (0, exports.getExceptionalAmounts)(selectedGame, ticket, withMultiplier);
    if (exceptionalAmount > 0) {
        return exceptionalAmount;
    }
    return (0, exports.isIneligibleCriteriaForMultiplier)(selectedGame, ticket)
        ? ticket.winningAmount
        : withMultiplier
            ? ticket.winningAmount * multiplier
            : ticket.winningAmount;
};
exports.getTotalWinningAmount = getTotalWinningAmount;
var getExceptionalAmounts = function (selectedGame, ticket, withMultiplier) {
    var gameName = selectedGame.name;
    var winningPositions = ticket.winningPositions;
    switch (gameName) {
        case 'Powerball': {
            var areAllMainNumbersMatching = (0, exports.getMatchingPositionCount)(winningPositions.slice(0, -1)) ===
                selectedGame.gameBoardConfig.main.digitCount;
            var isAddOnNumberMatching = winningPositions[winningPositions.length - 1] === 1;
            return areAllMainNumbersMatching && withMultiplier && !isAddOnNumberMatching ? 2000000 : 0;
        }
        default:
            return 0;
    }
};
exports.getExceptionalAmounts = getExceptionalAmounts;
var isIneligibleCriteriaForMultiplier = function (selectedGame, ticket) {
    var gameName = selectedGame.name;
    var winningPositions = ticket.winningPositions;
    switch (gameName) {
        case 'Powerball': {
            var areAllMainNumbersMatching = (0, exports.getMatchingPositionCount)(winningPositions.slice(0, -1)) ===
                selectedGame.gameBoardConfig.main.digitCount;
            return (areAllMainNumbersMatching ||
                (areAllMainNumbersMatching && winningPositions[winningPositions.length - 1]));
        }
        case 'Mega Millions':
        case 'Lotto America': {
            var areAllNumbersMatching = (0, exports.getMatchingPositionCount)(winningPositions) ===
                selectedGame.gameBoardConfig.main.digitCount + 1;
            return areAllNumbersMatching;
        }
        default:
            return false;
    }
};
exports.isIneligibleCriteriaForMultiplier = isIneligibleCriteriaForMultiplier;
var getMatchingPositionCount = function (winningPositions) {
    var numberOfOnes = winningPositions.reduce(function (count, currentValue) {
        if (currentValue === 1) {
            return count + 1;
        }
        else {
            return count;
        }
    }, 0);
    return numberOfOnes;
};
exports.getMatchingPositionCount = getMatchingPositionCount;
var validMultiplierGames = ['Powerball', 'Mega Millions', 'Lotto America'];
var getShowMultiplierLabel = function (selectedGame) {
    return validMultiplierGames.includes(selectedGame.name);
};
exports.getShowMultiplierLabel = getShowMultiplierLabel;
//# sourceMappingURL=utils.js.map